import styled, { css } from 'styled-components';
import Link from 'next/link';
import { FlexibleDiv } from '../../../../styled/common';
import { ChipsText } from '../../../ui/Chips/styled';
import { Breakpoints } from '../../../../styled/constants';

export const AgencyFilterHeaderContainer = styled(FlexibleDiv)<{
  $isCurrentItemPage: boolean;
}>`
  flex-wrap: nowrap;
  width: auto;
  height: 64px;
  padding: 10px
    ${({ $isCurrentItemPage }) => ($isCurrentItemPage ? '20px' : '15px')};
  margin: 10px 0;
  overflow-y: hidden;
  overflow-x: auto;
  position: sticky;
  top: 0;
  z-index: 3;
  background-color: ${({ theme }) => theme.colors.background.primary};
  -ms-overflow-style: none;
  scrollbar-width: none;
  gap: 10px;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 10px 40px;
  }

  @media (min-width: ${Breakpoints.desktop}px) {
    padding: 10px
      ${({ $isCurrentItemPage }) => ($isCurrentItemPage ? '20px' : '40px')};
  }
`;

export const chipsStyles = css`
  padding: 0 15px;

  ${ChipsText} {
    padding-top: 0;
  }
`;

export const ChipLink = styled(Link).attrs({
  prefetch: false
})`
  text-decoration: none;

  label {
    cursor: pointer;
  }
`;
